import React from "react";
import {Modal, Input, Table, Popover, Button, Tabs, DatePicker, Switch, Form} from "antd";
import {AddWasteProfile} from "./AddWasteProfile";
import InputNumber from "antd/es/input-number";
import {InvoicePayment} from "../account_components/InvoicePayment";

const FormItem = Form.Item;
const TabPane = Tabs.TabPane;

export class BillCredit extends React.Component {
  state={
    AddWasteProfile:false,
  }
  showAddWasteProfile=(visible)=>{
    this.setState({AddWasteProfile:visible})
  }

  render() {
    const { visible } = this.props;
    return (
      <Modal closable={false} centered visible={visible} onOk={() => this.props.onCancel()}
             onCancel={() => this.props.onCancel()} width='65%' className="view-data-modal view-hotsheet-mdl">
         <div className="row m-0">
            <div className="col-sm-4 col-12 view-modal-header">
              <h3><span>Billing & Credit</span></h3>
            </div>
            <div className="col-12 view-modal-header billing-tabs">
               <Tabs type="card" defaultActiveKey="1">
                  <TabPane tab="Credit Saving" key="1">
                    <div className="row full-floating-inputs">
                      <div className="col-sm-6 col-12">
                        <div className="floating-label">
                          <FormItem label="Amount">
                            <InputNumber placeholder="Enter Here"/>
                          </FormItem>
                        </div>
                      </div>
                      <div className="col-sm-6 col-12">
                        <div className="floating-label">
                          <FormItem label="Days">
                            <InputNumber placeholder="Enter Here"/>
                          </FormItem>
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="floating-label">
                          <FormItem label="Notes">
                            <Input placeholder="Enter Here"/>
                          </FormItem>
                        </div>
                      </div>
                      <div className="col-sm-4 col-12">
                        <div className="floating-label">
                          <FormItem label="COD">
                            <Switch defaultChecked  />
                          </FormItem>
                        </div>
                      </div>
                      <div className="col-sm-4 col-12">
                        <div className="floating-label">
                          <FormItem label="Notes">
                            <Switch defaultChecked />
                          </FormItem>
                        </div>
                      </div>
                    </div>
                  </TabPane>
                  <TabPane tab="Invoice & Payment" key="2">
                    <InvoicePayment/>
                  </TabPane>
                  <TabPane tab="Credit Application" key="3"> </TabPane>
               </Tabs>
            </div>
         </div>
      </Modal>
    )
  }
}


// WEBPACK FOOTER //
// ./src/pages/account/popups/BillCredit.jsx